module.exports = __webpack_public_path__ + "img/straps_length.a5604c54.png";